import { ReactNode } from 'react';

import { QuestionnaireProgressTabProps } from '@backrs_ui/common-ui/src/atoms/QuestionnaireProgressTab';
import {
  Pagination,
  PaginationProps,
} from '@backrs_ui/common-ui/src/molecules/Pagination/Pagination';

import { Box, SxProps, Theme } from '@mui/material';

import { QuestionnaireProgressTabs } from './QuestionnaireProgressTabs';

export type QuestionnaireProps = Readonly<{
  tabs: QuestionnaireProgressTabProps[];
  activeTabId?: string;
  activeSubcategoryId?: string;
  onSubcategoryClick?: (tabId: string, subcategoryId: string) => void;
  paginationProps: PaginationProps;
  children: ReactNode;
  showSubcategories?: boolean;
}>;

export const Questionnaire = ({
  tabs,
  activeTabId,
  activeSubcategoryId,
  onSubcategoryClick,
  paginationProps,
  children,
  showSubcategories = true,
}: QuestionnaireProps) => {
  return (
    <Box sx={containerSx}>
      <Box sx={tabsContainerSx}>
        <QuestionnaireProgressTabs
          tabs={tabs}
          activeTabId={activeTabId}
          activeSubcategoryId={activeSubcategoryId}
          onSubcategoryClick={onSubcategoryClick}
          showSubcategories={showSubcategories}
        />
      </Box>

      <Box sx={contentContainerSx}>{children}</Box>

      <Box sx={paginationWrapperSx}>
        <Pagination {...paginationProps} sticky />
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  position: 'relative',
};

const paginationWrapperSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'sticky',
  bottom: 0,
  zIndex: 2,
  mx: backrs.spacing['spacing-2xl'],
});

const tabsContainerSx: SxProps<Theme> = ({ backrs }) => ({
  pb: backrs.spacing['spacing-2xl'],
  position: 'sticky',
  top: 0,
  zIndex: 1,
  maxWidth: '1280px',
  width: '100%',
  margin: '0 auto',
  backgroundColor: backrs.colors['Beige/25'],
});

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'auto',
  marginBottom: 0,
  marginLeft: backrs.spacing['spacing-2xl'],
  marginRight: backrs.spacing['spacing-2xl'],
  boxSizing: 'border-box',
});
